/* global jQuery */
const $ = jQuery;

const initStickyButton = ($el) => {
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.intersectionRatio === 0) {
                $('.article-education__button').fadeIn();
            } else {
                $('.article-education__button').fadeOut();
            }
        });
    }, {
        rootMargin: '0px',
        threshold: 0,
    });

    const elements = [document.querySelector('.footer'), $el];

    elements.forEach((element) => {
        observer.observe(element);
    });
};

export default initStickyButton;
